import { Stack } from '@mantine/core';
import { useRef } from 'react';
import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import { ThroughputMode } from '../../initiative-performance.type';
import { ContributingEpicsChart } from './contributing-epics-chart/contributing-epics-chart';
import { ContributingInitiativesChart } from './contributing-initiatives-chart/contributing-initiatives-chart';
import { ContributingOutcomesChart } from './contributing-outcomes-chart/contributing-outcomes-chart';
import { ContributingTeamsChart } from './contributing-teams-chart/contributing-teams-chart';
import { InitiativeProgressChart } from './initiative-progress-chart/initiative-progress-chart';
import { MainSectionHeader } from './main-section-header';

export const MainSection = () => {
  const throughputMode = useThroughputTabStore((state) => state.mode);

  const chartRef = useRef<HTMLDivElement>(null!);

  return (
    <Stack h="100%" style={{ overflow: 'hidden' }}>
      <MainSectionHeader chartRef={chartRef} />
      {throughputMode === ThroughputMode.InitiativeProgress && <InitiativeProgressChart ref={chartRef} />}
      {throughputMode === ThroughputMode.ContributingEpics && <ContributingEpicsChart ref={chartRef} />}
      {throughputMode === ThroughputMode.ContributingTeams && <ContributingTeamsChart ref={chartRef} />}
      {throughputMode === ThroughputMode.ContributingInitiatives && <ContributingInitiativesChart ref={chartRef} />}
      {throughputMode === ThroughputMode.ContributingOutcomes && <ContributingOutcomesChart ref={chartRef} />}
    </Stack>
  );
};
